export const dishModalFullscreenBreakpoint = '@media ((max-width: 960px) and (max-height: 850px))';
